<template>
  <div class="app-container">
    <div style="margin-bottom: 10px;">
      <el-button type="primary" style="margin-left: 4px;" @click="newAdd" :disabled="!canWrite">新增</el-button>
      <el-button type="primary" style="margin-left: 4px;" @click="save" :disabled="Status === 2 || !canWrite">保存</el-button>
      <el-button type="primary" style="margin-left: 4px;" :disabled="!isSave || Status === 2 || !canWrite" @click="handleDelete">删除</el-button>
      <el-button type="primary" style="margin-left: 4px" @click="reView" v-if="Status !== 2" :disabled="!isSave || !canReview">审核</el-button>
      <el-button type="primary" style="margin-left: 4px" @click="cancelReView" v-if="Status === 2" :disabled="!isSave || !canReview">弃审</el-button>
      <el-dropdown style="margin-left: 4px;">
        <el-button type="primary" :disabled="!isSave">
          联查<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown" style="margin-left: 4px;">
          <el-dropdown-item class="dropdown-item">其他出库单</el-dropdown-item>
          <el-dropdown-item class="dropdown-item">其他入库单</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button type="primary" style="margin-left: 4px;">打印</el-button>
      <el-button type="primary" @click="openSetField">明细字段</el-button>
    </div>
    <el-form :key="resetDom" :model="data" ref="form" :inline="true" :line-form="true" label-width="80px" status-icon>
      <el-row style="margin-top: 18px;">
        <el-form-item label="单据日期:" required label-width="100px">
          <span class="not-edit" v-if="Status === 2">{{ data.ChgDate }}</span>
          <el-date-picker v-else v-model="data.ChgDate" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期" style="width:180px"
            @change="(v) => getPreviewNo(v)">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="单据编码:" required label-width="100px">
          <span style="display:inline-block;width:180px;" v-if="Mode == 0" class="detail-span">{{ data.ChgNumber }}</span>
          <el-input style="width:180px" v-else v-model="data.ChgNumber" placeholder="请输入单据编码"></el-input>
        </el-form-item>
        <el-form-item label="部门:" required label-width="100px">
          <span class="not-edit" v-if="Status === 2">{{
            data.DpName
          }}</span>
          <v-select v-else style="width:180px;" ref="typeSelect" v-model="data.DpId" />
        </el-form-item>
        <el-form-item label="入库类别:" required label-width="100px">
          <type-inselect ref="typeInSelect" :disabledStatus="Status" v-model="data.InClassId" style="width:180px;" />
        </el-form-item>
        <el-form-item label="出库类别:" required label-width="100px">
          <type-outselect ref="typeOutSelect" :disabledStatus="Status" v-model="data.OutClassId" style="width:180px;" />
        </el-form-item>
        <el-form-item label="经手人:" required label-width="100px">
          <span class="not-edit" v-if="Status === 2">{{ data.EmpName }}</span>
          <select-input v-else placeholder="请选择经办人" :label="data.EmpName" v-model="data.EmpId" @click="openEmp" style="width: 180px" />
        </el-form-item>
        <el-form-item label="制单人:" label-width="100px">
          <span class="span" style="width:180px !important;">{{
            data.MakeEmpName
          }}</span>
        </el-form-item>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="备注:" label-width="100px">
            <el-input type="textarea" v-model="data.Remark" :autosize="{ minRows: 2, maxRows: 4 }" maxlength="60" placeholder="请填写备注信息" :disabled="Status === 2"
              style="width: 600px" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="div">转换前明细 </div>
    <el-table border class="table_bottom table-line tb-c-head" :data="tableDataBefore" stripe style="margin-top: 18px;"
      @row-click="(row, column, e) => add(row, column, e, 'before')" :row-class-name="tableRowClassName" v-keymove="newLine" v-if="showDetail">
      <insert-row @on-insert="onInsert" />
      <el-table-column min-width="160" align="center" label="备注" v-if="showField('备注')">
        <template slot-scope="{ row }">
          <span v-if="Status === 2">{{ row.Remark }}</span>
          <el-input v-else v-model="row.Remark" @change="editT(row)" placeholder="请输入备注" />
        </template>
      </el-table-column>
      <el-table-column label="仓库" prop="WarehouseId" align="center" min-width="120" v-if="showField('仓库')">
        <template slot-scope="{ row }">
          <span class="not-edit" v-if="Status === 2">{{ row.WarehouseName }}</span>
          <el-select v-else v-model="row.WarehouseId" @change="changeWarehouse($event, row)">
            <el-option v-for="item in warehouseList" :key="item.key" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="存货名称" prop="ProductName" align="center" min-width="100" v-if="showField('存货名称')">
        <template slot-scope="{ row }">
          <span class="not-edit" v-if="Status === 2">{{ row.ProductName }}</span>
          <account-select v-else v-model="row.ProductName" :source="DAccount" @select="onSelect($event,row, 'before')" :pageSize="pageParams.pageSize"
            :pageIndex="pageParams.pageIndex" :listTotal='listTotal' @inputText="inputText($event, row)" @click.native="resetFun" @currentPage="currentPage($event, row)"
            :pageType='true' />
        </template>
      </el-table-column>
      <el-table-column label="存货编码" prop="ProductNo" align="center" min-width="160" v-if="showField('存货编码')">
      </el-table-column>
      <el-table-column label="规格型号" prop="ProductSpec" align="center" min-width="100" v-if="showField('规格型号')">
      </el-table-column>
      <el-table-column label="属性" prop="PropertyId" align="center" min-width="100" key="table1_6" v-if="showField('属性')">
        <template slot-scope="{ row }">
          <el-select v-if="row.UseProcess && Status !== 2" v-model="row.PropertyId" @change="changeProperty($event, row)">
            <el-option v-for="item in propertyList" :key="item.PropertyId" :label="item.PropertyName" :value="item.PropertyId"></el-option>
          </el-select>
          <span class="not-edit" v-else>{{ row.UseProcess ? row.PropertyName : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="颜色" prop="ColorId" align="center" min-width="100" key="table1_7" v-if="showField('颜色')">
        <template slot-scope="{ row }">
          <el-select v-if="row.UseColor && Status !== 2" v-model="row.ColorId" @change="changeColor($event, row)">
            <el-option v-for="item in row.Colors" :key="item.ColorId" :label="item.ColorName" :value="item.ColorId" :disabled="item.Status==0"></el-option>
          </el-select>
          <span class="not-edit" v-else>{{ row.UseColor ? row.ColorName : ""}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="计量单位" min-width="120px" v-if="showField('计量单位')">
        <template slot-scope="{ row, $index }">
          <el-select v-if="row.Units && row.Units.length > 0&& row.HasGrammage != true" v-model="row.UnitId" :disabled="Status === 2">
            <el-option v-for="item in row.Units" :key="item.UnitId" :value="item.UnitId" :label="item.UnitName"
              @click.native="compareSaUnit(item, row, $index, 'before')"></el-option>
          </el-select>
          <span v-else>{{ row.UnitName }}</span>
        </template>
        <!--  -->
      </el-table-column>
      <el-table-column align="center" label="计量单位2" min-width="120px" v-if="showField('计量单位2')">
        <template slot-scope="{ row, $index }">
          <!-- <span>{{ row }}{{ $index }}</span> -->
          <el-select v-if="row.Units && row.Units.length > 0&& row.HasGrammage != true" v-model="row.UnitId2" :disabled="Status === 2">
            <el-option v-for="item in row.Units" :key="item.UnitId" :value="item.UnitId" :label="item.UnitName"
              @click.native="compareUnitId(item, row, $index, 'before')"></el-option>
          </el-select>
          <span v-else-if="row.UnitType == 0"></span>
          <span v-else>{{ row.UnitName2 }}</span>
        </template>
      </el-table-column>
      <el-table-column label="数量" prop="SkQuantity" align="center" min-width="100" key="table1_9" v-if="showField('数量')">
        <template slot-scope="{ row, $index }">
          <span class="not-edit" v-if="Status === 2">{{ $commonJs.toThousands(row.SkQuantity) }}</span>
          <el-input type="text" v-else @change="changeQuantity($event, row, $index)" v-model="row.SkQuantity"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="数量2" prop="Quantity2" align="center" min-width="100" v-if="showField('数量2')">
        <template slot-scope="{ row, $index }">
          <span class="not-edit" v-if="Status === 2">{{ $commonJs.toThousands(row.Quantity2) }}</span>
          <el-input v-else v-show="row.UnitId2 || (row.Units2 && row.Units2.length !== 0)" type="text" v-model="row.Quantity2"
            @change="changeQuantity2($event, row, $index)"></el-input>
        </template>
      </el-table-column>
      <el-table-column align="center" label="换算率" v-if="showField('换算率')">
        <template slot-scope="{ row, $index }">
          <span v-if="(Status === 2 || row.ChangeType === 0) && row.UnitType == 1">{{ row.Rate }}</span>
          <span v-else-if="row.UnitType == 0"></span>
          <el-input v-else type="text" v-model="row.Rate" @input="RateChange($event, row, $index)"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="单价" prop="Price" align="center" min-width="100" key="table1_10" v-if="canPrice&&showField('单价')">
        <template slot-scope="{ row }">
          <span class="not-edit" v-if="Status === 2">{{ row.Price }}</span>
          <el-input type="text" v-else @change="changePrice($event, row)" v-model="row.Price"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="单价2" prop="Price2" align="center" min-width="100" v-if="canPrice&&showField('单价2')">
        <template slot-scope="{ row }">
          <span class="not-edit" v-if="Status === 2">{{ row.Price2 }}</span>
          <el-input v-else v-show="row.UnitId2 || (row.Units2 && row.Units2.length !== 0)" type="text" v-model="row.Price2" @change="changePrice2($event, row)"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="金额" prop="Amount" align="center" min-width="100" key="table1_11" v-if="canPrice&&showField('金额')">
        <template slot-scope="{ row }">
          <span class="not-edit" v-if="Status === 2">{{ $commonJs.toThousands(row.Amount) }}</span>
          <el-input type="text" v-else @change="changeAmount($event, row)" v-model="row.Amount"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" align="center" width="80">
        <template slot-scope="{ row, $index }">
          <el-button type="text" @click="del(row, $index, 'before')" :disabled="Status === 2">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="div">转换后明细</div>
    <el-table border class="table_bottom table-line tb-c-head" :data="tableDataAfter" stripe style="margin-top: 18px;" @row-click="(row, column, e) => add(row, column, e, 'after')"
      :row-class-name="tableRowClassName" v-keymove="newLine_after" v-if="showDetail">
      <insert-row @on-insert="onInsert_after" />
      <el-table-column min-width="160" align="center" label="备注" v-if="showField('备注')">
        <template slot-scope="{ row }">
          <span v-if="Status === 2">{{ row.Remark }}</span>
          <el-input v-else v-model="row.Remark" @change="editT(row)" placeholder="请输入备注" />
        </template>
      </el-table-column>
      <el-table-column label="仓库" prop="WarehouseId" align="center" min-width="120" v-if="showField('仓库')">
        <template slot-scope="{ row }">
          <span class="not-edit" v-if="Status === 2">{{ row.WarehouseName }}</span>
          <el-select v-else v-model="row.WarehouseId" @change="changeWarehouse($event, row)">
            <el-option v-for="item in warehouseList" :key="item.key" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="存货名称" prop="ProductName" align="center" min-width="100" v-if="showField('存货名称')">
        <template slot-scope="{ row }">
          <span class="not-edit" v-if="Status === 2">{{ row.ProductName }}</span>
          <account-select v-else v-model="row.ProductName" :source="DAccount" @select="onSelect($event,row, 'after')" :pageSize="pageParams.pageSize"
            :pageIndex="pageParams.pageIndex" :listTotal='listTotal' @inputText="inputText($event, row)" @click.native="resetFun" @currentPage="currentPage($event, row)"
            :pageType='true' />
        </template>
      </el-table-column>
      <el-table-column label="存货编码" prop="ProductNo" align="center" min-width="160" v-if="showField('存货编码')">
      </el-table-column>
      <el-table-column label="规格型号" prop="ProductSpec" align="center" min-width="100" v-if="showField('规格型号')">
      </el-table-column>
      <el-table-column label="属性" prop="PropertyId" align="center" min-width="100" key="table1_6" v-if="showField('属性')">
        <template slot-scope="{ row }">
          <el-select v-if="row.UseProcess && Status !== 2" v-model="row.PropertyId" @change="changeProperty($event, row)">
            <el-option v-for="item in propertyList" :key="item.PropertyId" :label="item.PropertyName" :value="item.PropertyId"></el-option>
          </el-select>
          <span class="not-edit" v-else>{{ row.UseProcess ? row.PropertyName : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="颜色" prop="ColorId" align="center" min-width="100" key="table1_7" v-if="showField('颜色')">
        <template slot-scope="{ row }">
          <el-select v-if="row.UseColor && Status !== 2" v-model="row.ColorId" @change="changeColor($event, row)">
            <el-option v-for="item in row.Colors" :key="item.ColorId" :label="item.ColorName" :value="item.ColorId" :disabled="item.Status==0"></el-option>
          </el-select>
          <span class="not-edit" v-else>{{ row.UseColor ? row.ColorName : ""}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="计量单位" min-width="120px" v-if="showField('计量单位')">
        <template slot-scope="{ row, $index }">
          <el-select v-if="row.Units && row.Units.length > 0&& row.HasGrammage != true" v-model="row.UnitId" :disabled="Status === 2">
            <el-option v-for="item in row.Units" :key="item.UnitId" :value="item.UnitId" :label="item.UnitName"
              @click.native="compareSaUnit(item, row, $index, 'after')"></el-option>
          </el-select>
          <span v-else>{{ row.UnitName }}</span>
        </template>
        <!--  -->
      </el-table-column>
      <el-table-column align="center" label="计量单位2" min-width="120px" v-if="showField('计量单位2')">
        <template slot-scope="{ row, $index }">
          <!-- <span>{{ row }}{{ $index }}</span> -->
          <el-select v-if="row.Units && row.Units.length > 0&& row.HasGrammage != true" v-model="row.UnitId2" :disabled="Status === 2">
            <el-option v-for="item in row.Units" :key="item.UnitId" :value="item.UnitId" :label="item.UnitName"
              @click.native="compareUnitId(item, row, $index, 'after')"></el-option>
          </el-select>
          <span v-else-if="row.UnitType == 0"></span>
          <span v-else>{{ row.UnitName2 }}</span>
        </template>
      </el-table-column>
      <el-table-column label="数量" prop="SkQuantity" align="center" min-width="100" key="table1_9" v-if="showField('数量')">
        <template slot-scope="{ row, $index }">
          <span class="not-edit" v-if="Status === 2">{{ $commonJs.toThousands(row.SkQuantity) }}</span>
          <el-input type="text" v-else @change="changeQuantity($event, row, $index)" v-model="row.SkQuantity"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="数量2" prop="Quantity2" align="center" min-width="100" v-if="showField('数量2')">
        <template slot-scope="{ row, $index }">
          <span class="not-edit" v-if="Status === 2">{{ $commonJs.toThousands(row.Quantity2) }}</span>
          <el-input v-else v-show="row.UnitId2 || (row.Units2 && row.Units2.length !== 0)" type="text" v-model="row.Quantity2"
            @change="changeQuantity2($event, row, $index)"></el-input>
        </template>
      </el-table-column>
      <el-table-column align="center" label="换算率" v-if="showField('换算率')">
        <template slot-scope="{ row, $index }">
          <span v-if="(Status === 2 || row.ChangeType === 0) && row.UnitType == 1">{{ row.Rate }}</span>
          <span v-else-if="row.UnitType == 0"></span>
          <el-input v-else type="text" v-model="row.Rate" @input="RateChange($event, row, $index)"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="单价" prop="Price" align="center" min-width="100" key="table1_10" v-if="canPrice&&showField('单价')">
        <template slot-scope="{ row }">
          <span class="not-edit" v-if="Status === 2">{{ row.Price }}</span>
          <el-input type="text" v-else @change="changePrice($event, row)" v-model="row.Price"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="单价2" prop="Price2" align="center" min-width="100" v-if="canPrice&&showField('单价2')">
        <template slot-scope="{ row }">
          <span class="not-edit" v-if="Status === 2">{{ row.Price2 }}</span>
          <el-input v-else v-show="row.UnitId2 || (row.Units2 && row.Units2.length !== 0)" type="text" v-model="row.Price2" @change="changePrice2($event, row)"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="金额" prop="Amount" align="center" min-width="100" key="table1_11" v-if="canPrice&&showField('金额')">
        <template slot-scope="{ row }">
          <span class="not-edit" v-if="Status === 2">{{ $commonJs.toThousands(row.Amount) }}</span>
          <el-input type="text" v-else @change="changeAmount($event, row)" v-model="row.Amount"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" align="center" width="80">
        <template slot-scope="{ row, $index }">
          <el-button type="text" @click="del(row, $index, 'after')" :disabled="Status === 2">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="mtx10">
      <div class="flex space-between">
        <div class="flex flex1">
          <div class="mrx18 center el-form-item__label">审核人</div>
          <div class="center el-form-item__label">{{ data.ReviewEmpName }}</div>
        </div>
        <div class="flex flex1">
          <div class="mrx18 center el-form-item__label">审核时间</div>
          <div class="center el-form-item__label">{{ data.ReviewDate }}</div>
        </div>
      </div>
    </div>
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    <field-dialog ref="fieldDialog" @close-saved="setTbField" />
  </div>
</template>
<script>
import accountSelect from "@/components/business/stock/select";
import vSelect from "@/components/business/stock/productionpicking/vSelect";
import empDialog from "@/components/personnel/result/record/listDialog";
import optionMixins from "@/mixins/option";
import typeInselect from "./inSelect";
import typeOutselect from "./outSelect";
import fieldDialog from "@/components/common/fieldDialog"

export default {
  mixins: [optionMixins],
  name: "editpatternconversion",
  components: {
    accountSelect,
    vSelect,
    empDialog,
    typeInselect,
    typeOutselect,
    fieldDialog,
  },
  data() {
    return {
      resetDom: Date.now(),
      headKeepData: [],
      footKeepData: [],
      pdApi: require("@/api/ba/product").default,
      code_api: require("@/api/sy/serialCode").default,
      api: require("@/api/stock/skGoodsChg").default,
      unit_Api: require("@/api/ba/unit").default,
      propertyApi: require("@/api/ba/property").default,
      warehouseApi: require("@/api/ba/warehouse").default,
      docSetting_api: require('@/api/sy/docSetting').default,
      warehouseList: [],
      propertyList: [],
      Mode: 0,
      initDAccount: [],
      initTotal: 0,
      DAccount: [],
      listTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
      isSave: false,
      Status: 0,
      viewType: "create",
      data: {
        GoodsChgId: 0,
        ChgDate: this.$commonJs.getToday(),
        ChgNumber: "",
        DpId: 0,
        DpName: "",
        EmpName: "",
        EmpId: 0,
        MakeEmpName: "",
        MakeEmpId: 0,
        ReviewEmpName: "",
        ReviewEmpId: 0,
        ReviewDate: "",
        Remark: "",
        InClassId: 0,
        OutClassId: 0,
      },
      date: [],
      delTableDataBefore: [],
      tableDataBefore: [
        {
          T: 0,
          GoodsChgId: 0,
          GoodsChgBeginDetailId: 0,
          ChgNumber: "",
          WarehouseId: null,
          WarehouseName: "",
          ProductId: null,
          ProductNo: "",
          ProductName: "",
          ProductSpec: "",
          PropertyId: null,
          PropertyName: "",
          ColorId: null,
          ColorName: "",
          Colors: [],
          Units: [],
          UnitId: null,
          UnitName: "",
          UnitId2: 0,
          UnitName2: "",
          SkQuantity: null,
          Price: null,
          Amount: null,
          SkUnitId: 0,
          SkUnitName: "",
          Quantity2: null,
          Rate: null,
          BatchNumber: "",
          TaxRate: 0,
          Price2: null,
          TaxPrice: 0,
          TaxAmount: 0,
          TaxLimit: 0,
          Remark: "",
        },
      ],
      tableDataAfter: [
        {
          T: 0,
          GoodsChgId: 0,
          GoodsChgEndDetailId: 0,
          ChgNumber: "",
          WarehouseId: null,
          WarehouseName: "",
          ProductId: null,
          ProductNo: "",
          ProductName: "",
          ProductSpec: "",
          PropertyId: null,
          PropertyName: "",
          ColorId: null,
          ColorName: "",

          Colors: [],
          Units: [],
          UnitId: null,
          UnitName: "",
          UnitId2: 0,
          UnitName2: "",
          SkQuantity: null,
          Price: null,
          Amount: null,
          SkUnitId: 0,
          SkUnitName: "",
          Quantity2: null,
          Rate: null,
          BatchNumber: "",
          TaxRate: 0,
          Price2: null,
          TaxPrice: 0,
          TaxAmount: 0,
          TaxLimit: 0,
          Remark: "",
        },
      ],
      tableData: [],
      delTableDataAfter: [],
      isUseProcessAfter: true,
      isUseColorAfter: true,
      isUseProcessBefore: true,
      isUseColorBefore: true,
      detailFields: [],
      showDetail: false
    };
  },
  created() {
    this.init();
  },
  computed: {
    canPrice() {
      return this.$permission.canPrice("/business/stock/patternconversion");
    },
    canWrite() {
      return this.$permission.canWrite("/business/stock/patternconversion");
    },
    canReview() {
      return this.$permission.canReview("/business/stock/patternconversion");
    },
  },
  mounted() {
    this.viewType = this.$route.params.type;
    this.$refs.typeInSelect.init();
    this.$refs.typeOutSelect.init();

    if (this.$route.params.type === "create") {
      this.getPreviewNo();
      const user = this.$store.state.user;
      if (user) {
        this.data.EmpId = user.empId;
        this.data.EmpName = user.name;
      }
    } else if (this.$route.params.type === "edit") {
      this.editInit(this.$route.params.data);
    }
  },
  methods: {
    openSetField() {
      this.$refs.fieldDialog.open().then(that => {
        that.getData({ DocType: "形态转换单", Url: "business/stock/patternconversion/edit" });
      })
    },
    setTbField() {
      this.showDetail = false;
      this.docSetting_api.list({ DocType: "形态转换单", IsShow: true }).then(res => {
        if (res.Code == 0) {
          this.detailFields = res.Data.map(x => x.FormKey);
          this.$nextTick(() => {
            this.showDetail = true;
          })
        }
      })
    },
    showField(type) {
      return this.detailFields.indexOf(type) != -1;
    },
    onInsert(e) {
      let { type, index } = e;

      this.interpolate(null, index, type)

    },
    onInsert_after(e) {
      let { type, index } = e;
      this.interpolate_after(null, index, type)
    },
    interpolate(row, index, type = "") {
      let o = {
        T: 0,
        GoodsChgId: 0,
        GoodsChgBeginDetailId: 0,
        ChgNumber: "",
        WarehouseId: null,
        WarehouseName: "",
        ProductId: null,
        ProductNo: "",
        ProductName: "",
        ProductSpec: "",
        PropertyId: null,
        PropertyName: "",
        ColorId: null,
        ColorName: "",
        Colors: [],
        Units: [],
        UnitId: null,
        UnitName: "",
        SkQuantity: 0,
        Price: 0,
        Amount: 0,
        SkUnitId: 0,
        SkUnitName: "",
        Quantity2: 0,
        Rate: 0,
        BatchNumber: "",
        TaxRate: 0,
        Price2: 0,
        TaxPrice: 0,
        TaxAmount: 0,
        TaxLimit: 0,
      };
      if (type == "down") {
        index = index + 1;
      }
      this.tableDataBefore.splice(index, 0, o);
      let copy = JSON.parse(JSON.stringify(this.tableDataBefore));
      this.tableDataBefore = [];
      this.$nextTick(() => {

        this.tableDataBefore = copy;
      })
      console.log("this.tableData", this.tableDataBefore)

    },
    interpolate_after(row, index, type = "") {
      let o = {
        T: 0,
        GoodsChgId: 0,
        GoodsChgBeginDetailId: 0,
        ChgNumber: "",
        WarehouseId: null,
        WarehouseName: "",
        ProductId: null,
        ProductNo: "",
        ProductName: "",
        ProductSpec: "",
        PropertyId: null,
        PropertyName: "",
        SkQuantity: 0,
        ColorId: null,
        ColorName: "",
        Colors: [],
        Units: [],
        UnitId: null,
        UnitName: "",
        Price: 0,
        Amount: 0,
        SkUnitId: 0,
        SkUnitName: "",
        Quantity2: 0,
        Rate: 0,
        BatchNumber: "",
        TaxRate: 0,
        Price2: 0,
        TaxPrice: 0,
        TaxAmount: 0,
        TaxLimit: 0,
        Remark: "",
      };
      if (type == "down") {
        index = index + 1;
      }
      this.tableDataAfter.splice(index, 0, o);
      let copy = JSON.parse(JSON.stringify(this.tableDataAfter));
      this.tableDataAfter = [];
      this.$nextTick(() => {

        this.tableDataAfter = copy;
      })
      console.log("this.tableData", this.tableDataAfter)

    },
    setEmp(data) {
      console.log(data);
      this.data.EmpId = data.EmpId;
      this.data.EmpName = data.EmpName;
    },
    openEmp() {
      this.$refs.empDialog.open().then((that) => {
        that.getData();
      });
    },
    getPreviewNo(dateTime = "") {
      this.code_api.previewNo("形态转换单", dateTime).then((res) => {
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.ChgNumber = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取形态转换单编号失败");
        }
      });
    },
    init() {

      this.propertyApi.list({
        Status: 1
      }).then(res => {

        if (res.Code === 0) {
          this.propertyList = res.Data;
        }
      })

      this.pdApi
        .list({
          Status: 1,
          PageIndex: this.pageParams.pageIndex,
          pageSize: this.pageParams.pageSize,
        })
        .then((res) => {
          this.DAccount = res.Data;
          this.initDAccount = res.Data;
          this.listTotal = res.Count;
          this.initTotal = res.Count;
        });

      this.warehouseApi.list({ Status: 1, WarehouseType: 1 }).then((res) => {
        if (res.Code === 0) {
          this.warehouseList = res.Data.map((item) => {
            return {
              key: item.WarehouseId,
              label: item.WarehouseName,
              value: item.WarehouseId,
            };
          });
        }
      });

      this.callOptionApi();
      this.setTbField();
    },
    cycleChange(t) {
      var today = this.$commonJs.getToday();
      var start = "";
      var end = "";
      switch (t) {
        case "今天":
          start = today;
          end = today;
          break;
        case "昨天":
          start = this.$dayjs()
            .subtract(1, "day")
            .format("YYYY-MM-DD");
          end = start;
          break;
        case "近3天":
          start = this.$dayjs()
            .subtract(2, "day")
            .format("YYYY-MM-DD");
          end = today;
          break;
        case "近7天":
          start = this.$dayjs()
            .subtract(6, "day")
            .format("YYYY-MM-DD");
          end = today;
          break;
        case "近14天":
          start = this.$dayjs()
            .subtract(13, "day")
            .format("YYYY-MM-DD");
          end = today;
          break;
        case "本周":
          start = this.$dayjs()
            .startOf("week")
            .format("YYYY-MM-DD");
          end = today;
          break;
        case "上周":
          var week = this.$dayjs().subtract(1, "week");
          start = week.startOf("week").format("YYYY-MM-DD");
          end = week.endOf("week").format("YYYY-MM-DD");
          break;
        case "本月":
          start = this.$dayjs()
            .startOf("month")
            .format("YYYY-MM-DD");
          end = today;
          break;
        case "上月":
          var month = this.$dayjs().subtract(1, "month");
          start = month.startOf("month").format("YYYY-MM-DD");
          end = month.endOf("month").format("YYYY-MM-DD");
          break;
        case "本季":
          start = this.$dayjs()
            .startOf("quarter")
            .format("YYYY-MM-DD");
          end = today;
          break;
        case "上季":
          var quarter = this.$dayjs().subtract(1, "quarter");
          start = quarter.startOf("quarter").format("YYYY-MM-DD");
          end = quarter.endOf("quarter").format("YYYY-MM-DD");
          break;
        case "本年":
          start = this.$dayjs()
            .startOf("year")
            .format("YYYY-MM-DD");
          end = today;
          break;
        case "上年":
          var year = this.$dayjs().subtract(1, "year");
          start = year.startOf("year").format("YYYY-MM-DD");
          end = year.endOf("year").format("YYYY-MM-DD");
          break;
      }

      return {
        start, end
      }

    },
    editInit(data, type = 'edit') {
      this.viewType = 'edit'
      this.isSave = true;
      let {
        BeginDetailModels,
        BusinessTypeId,
        ChgDate,
        ChgNumber,
        DpId,
        DpName,
        EmpId,
        EmpName,
        EndDetailModels,
        GoodsChgId,
        MakeDate,
        MakeEmpId,
        MakeEmpName,
        Remark,
        ReviewDate,
        ReviewEmpId,
        ReviewEmpName = "",
        Status,
        UpdateDate = "",
        UpdateEmpId,
        InClassId,
        OutClassId,
      } = data;

      // let {start} = this.cycleChange('今天')
      UpdateDate = "";
      // UpdateEmpId = this.$commonJs.empId();

      this.Status = Status;



      this.data = {
        BusinessTypeId,
        ChgDate,
        ChgNumber,
        DpId,
        DpName,
        EmpId,
        EmpName,
        GoodsChgId,
        MakeDate,
        MakeEmpId,
        MakeEmpName,
        Remark,
        ReviewDate,
        ReviewEmpId,
        ReviewEmpName,
        Status,
        UpdateDate,
        UpdateEmpId,
        InClassId,
        OutClassId,
      }


      this.initProducts(BeginDetailModels, type, 'begin')
      this.tableDataBefore = BeginDetailModels;

      this.initProducts(EndDetailModels, type, 'end')
      this.tableDataAfter = EndDetailModels;
    },
    initProducts(data, type, flag) {
      data.forEach((item, index) => {

        item.T = null

        item.PropertyId = item.PropertyId !== 0 ? item.PropertyId : null;
        item.ColorId = item.ColorId !== 0 ? item.ColorId : null;
        item.WarehouseId = item.WarehouseId !== 0 ? item.WarehouseId : null;
        item.UnitId = item.SkUnitId;
        item.UnitName = item.SkUnitName;
        item.UnitType = 0;
        if (item.Units.length > 0) item.UnitType = 1;
        if (item.Units.length > 0 && item.SkUnitId) {
          const findIndex = item.Units.findIndex(el => el.UnitId == item.SkUnitId)
          // let  data=this.getUnitValue(item.Units,findIndex)
          // item.IsMain =data.IsMain
          const IsMainIndex = item.Units.findIndex(el => el.IsMain == true) //主单位的索引
          const UnitId2Index = item.Units.findIndex(el => el.UnitId == item.UnitId2) //不是主单位的索引 
          const noMainIndex = item.Units.findIndex(el => el.IsMain == false)
          if (findIndex == IsMainIndex) { //判断当前销售单位是否为主单位
            item.ChangeType = item.Units[UnitId2Index != -1 ? UnitId2Index : noMainIndex].ChangeType || 0
            item.IsMain = true;
          } else {
            //如果当前是赋单位
            item.ChangeType = item.Units[findIndex].ChangeType
            item.IsMain = false;
          }
        } else {
          item.Units.forEach(v => {
            if (v.ChangeType == 1) item.ChangeType = v.ChangeType
          })
        }

        if (type == 'keep') {
          if (flag == 'begin') {
            item.ChangeType = this.headKeepData[index].ChangeType;
          } else {
            item.ChangeType = this.footKeepData[index].ChangeType;
          }
        }
      })
    },
    changeWarehouse(val, row) {
      if (row.T !== 0) {
        row.T = 1;
      }

      let item = this.warehouseList.filter((item) => {
        return item.value === val;
      })[0];

      row.WarehouseName = item.label;
    },
    changeColor(val, row) {
      if (row.T !== 0) {
        row.T = 1;
      }

      let item = row.Colors.filter((item) => {
        return item.ColorId === val;
      })[0];

      row.ColorName = item.ColorName;
    },
    changeProperty(val, row) {
      if (row.T !== 0) {
        row.T = 1;
      }

      let item = this.propertyList.filter((item) => {
        return item.PropertyId === val;
      })[0];

      row.PropertyName = item.PropertyName;

    },
    //  changeUnit(val, row,index) {

    //   if (row.T !== 0) {
    //     row.T = 1;
    //   }
    //   console.log(row.Units,row)
    //   let item = row.Units.filter((item) => {
    //     return item.UnitId === val;
    //   })[0];   
    //   // row.UnitName=item.UnitName 
    //   this.$set(row,'UnitId',item.UnitId)
    //   this.$set(row,'UnitName',item.UnitName)
    //   this.$forceUpdate(); 
    //   console.log(this.tableDataBefore[0].UnitId,'UnitId')
    //   // row.UnitId=item.UnitId


    // },
    compareSaUnit(data, row, index, type) {

      if (type === 'before') {
        if (row.T === 3) row.T = 1;

        this.editT(row);

        let lastIsMain = row.IsMain;
        this.tableDataBefore[index].IsMain = data.IsMain;
        let findIndex = 0;
        if (row.UnitId == row.UnitId2) {
          let num = 0;
          num = row.SkQuantity;
          row.SkQuantity = row.Quantity2;
          row.Quantity2 = num;
          console.log('data.IsMain', data.IsMain)
          if (data.IsMain) {
            //当前选择的主单位
            findIndex = this.getUnitIndex(2, this.tableDataBefore[index].Units);
            this.changeRightUnitId(index, findIndex, type);
            // row.ChangeType1 = data.ChangeType;
          } else {
            findIndex = this.getUnitIndex(1, this.tableDataBefore[index].Units);
            console.log('findIndex', findIndex)
            this.changeRightUnitId(index, findIndex, type);
            // row.ChangeType1 = data.ChangeType;
          }
        } else {
          if (data.IsMain) {
            findIndex = this.getUnitIndex(2, this.tableDataBefore[index].Units);
            this.changeRightUnitId(index, findIndex, type);
            // row.ChangeType1 = data.ChangeType;
          } else {
            findIndex = this.getUnitIndex(1, this.tableDataBefore[index].Units);
            this.changeRightUnitId(index, findIndex, type, data.Rate);
            // row.ChangeType1 = data.ChangeType;
            if (lastIsMain) {
              row.Quantity2 = row.SkQuantity;
            }
            // row.Quantity = (row.Quantity2 / Number(data.Rate)).toFixed(2);
            row.SkQuantity = this.getQuantity(row.Quantity2 / Number(data.Rate));
          }
        }
        this.changeQuantity(this.tableDataBefore[index].SkQuantity, row, index, 1);

        let val = this.setNumber(Math.abs(row.Amount / row.SkQuantity));
        row.Price = this.getPrice(val);

        val = this.setNumber(Math.abs(row.Amount / row.Quantity2));
        row.Price2 = this.getPrice(val);
      } else {
        if (row.T === 3) row.T = 1;

        this.editT(row);

        let lastIsMain = row.IsMain;
        this.tableDataAfter[index].IsMain = data.IsMain;
        let findIndex = 0;
        if (row.UnitId == row.UnitId2) {
          let num = 0;
          num = row.SkQuantity;
          row.SkQuantity = row.Quantity2;
          row.Quantity2 = num;

          if (data.IsMain) {
            //当前选择的主单位
            findIndex = this.getUnitIndex(2, this.tableDataAfter[index].Units);
            this.changeRightUnitId(index, findIndex, type);
            // row.ChangeType1 = data.ChangeType;
          } else {
            findIndex = this.getUnitIndex(1, this.tableDataAfter[index].Units);
            this.changeRightUnitId(index, findIndex, type);
            // row.ChangeType1 = data.ChangeType;
          }
        } else {
          if (data.IsMain) {
            findIndex = this.getUnitIndex(2, this.tableDataAfter[index].Units);
            this.changeRightUnitId(index, findIndex, type);
            // row.ChangeType1 = data.ChangeType;
          } else {
            findIndex = this.getUnitIndex(1, this.tableDataAfter[index].Units);
            this.changeRightUnitId(index, findIndex, type, data.Rate);
            // row.ChangeType1 = data.ChangeType;
            if (lastIsMain) {
              row.Quantity2 = row.SkQuantity;
            }
            // row.Quantity = (row.Quantity2 / Number(data.Rate)).toFixed(2);
            row.SkQuantity = this.getQuantity(row.Quantity2 / Number(data.Rate));
          }
        }
        this.changeQuantity(this.tableDataAfter[index].SkQuantity, row, index, 1);

        let val = this.setNumber(Math.abs(row.Amount / row.SkQuantity));
        row.Price = this.getPrice(val);

        val = this.setNumber(Math.abs(row.Amount / row.Quantity2));
        row.Price2 = this.getPrice(val);
      }


    },
    changeRightUnitId(index, findIndex, type, Rate = 0) {
      if (type === 'before') {
        this.tableDataBefore[index].UnitId2 =
          this.tableDataBefore[index].Units[findIndex].UnitId;
        this.tableDataBefore[index].UnitName2 =
          this.tableDataBefore[index].Units[findIndex].UnitName;
        console.log('UnitId2', this.tableDataBefore[index].UnitId2)
        console.log('UnitName2', this.tableDataBefore[index].UnitName2)

        if (Rate > 0) {
          this.tableDataBefore[index].Rate = Rate;
        }
      } else {
        this.tableDataAfter[index].UnitId2 =
          this.tableDataAfter[index].Units[findIndex].UnitId;
        this.tableDataAfter[index].UnitName2 =
          this.tableDataAfter[index].Units[findIndex].UnitName;
        if (Rate > 0) {
          this.tableDataAfter[index].Rate = Rate;
        }
      }

      // this.tableData[index].ChangeType2 =
      //   this.tableData[index].Units[findIndex].ChangeType;


    },
    changeQuantity(data, row, index, type = 0) {
      if (data == "-" || data == "." || data == "") {
        return;
      }
      this.editT(row);
      data = this.setNumber(data)
      row.SkQuantity = this.getQuantity(data)
      // if (this.data.MinusEntry) {
      //   row.Quantity > 0 ? (row.Quantity = 0 - row.Quantity) : row.Quantity;
      //   row.Quantity2 > 0 ? (row.Quantity2 = 0 - row.Quantity2) : row.Quantity2;
      // } else {
      //   row.Quantity = Math.abs(row.Quantity);
      //   row.Quantity2 = Math.abs(row.Quantity2);
      // }
      // if (row.T == 3) this.tableData[index].T = 1;
      if (row.Units.length > 0) {
        if (row.IsMain) {
          // row.Quantity2= (row.Quantity / Number(row.Rate)).toFixed(2);
          //row.Quantity2 = this.getQuantity(row.SkQuantity / Number(row.Rate));
           if (row.HasGrammage == true) {
            row.Quantity2 = this.getQuantity(row.SkQuantity * Number(row.Rate))
          } else {
            row.Quantity2 = this.getQuantity(row.SkQuantity / Number(row.Rate))
          }
          if (type === 0) {
            row.Amount = this.setAmount(row.Price, row.SkQuantity);
          }
        } else {
          //row.Quantity2 = this.getQuantity(data * Number(row.Rate));
          if (row.HasGrammage == true) {
            row.Quantity2 = this.getQuantity(row.SkQuantity / row.Rate)
          } else {
            row.Quantity2 = this.getQuantity(row.SkQuantity * row.Rate)
          }
          if (type === 0) {
            row.Amount = this.setAmount(row.Price, row.SkQuantity);
          }
          // if (row.ChangeType1 == 1 && row.Quantity2 != 0) {
          //   row.Rate = Math.abs(Number(row.Quantity2 / data)).toFixed(2);
          //   if (type === 0) {
          //     let val = this.setNumber(Math.abs(row.Amount / data));
          //     row.Price = this.getPrice(val);
          //   }
          // } else if (row.Quantity2 == 0) {
          //   // row.Quantity2 = (data * Number(row.Rate)).toFixed(2);
          //   row.Quantity2 = this.getQuantity(data * Number(row.Rate));
          //   if (type === 0) {
          //     row.Amount = this.setAmount(row.Price, row.SkQuantity);
          //   }
          // } else if (row.ChangeType1 == 0) {
          //   // row.Quantity2 = (data * Number(row.Rate)).toFixed(2);
          //   row.Quantity2 = this.getQuantity(data * Number(row.Rate));
          //   if (type === 0) {
          //     row.Amount = this.setAmount(row.Price, row.SkQuantity);
          //   }
          // }
        }
      } else {
        // row.Quantity2 = row.SkQuantity;
        row.Amount = this.setAmount(row.Price, row.SkQuantity);
      }
    },
    getUnitValue(arr, findIndex) {
      let data = {};
      data.UnitId = arr[findIndex].UnitId;
      data.UnitName = arr[findIndex].UnitName;
      data.IsMain = arr[findIndex].IsMain;
      data.ChangeType = arr[findIndex].ChangeType;
      data.Rate = arr[findIndex].Rate;
      return data;
    },
    //获取计量单位主辅单位的索引
    getUnitIndex(type, arr, id = "") {
      let index = 0;
      if (type == 1) {
        //获取主单位索引
        index = arr.findIndex((el) => el.IsMain == true);
      } else if (type == 2) {
        //获取数组第一个不是主单位的索引
        index = arr.findIndex((el) => el.IsMain == false);
      } else {
        //获取当前传入id的索引
        index = arr.findIndex((el) => id == el.UnitId);
      }
      return index;
    },
    //  changeQuantity(val, row) {
    //   if (row.T !== 0) {
    //     row.T = 1;
    //   }
    //   val = this.setNumber(val)
    //   row.SkQuantity = parseFloat(this.getQuantity(parseFloat(val)));
    //   row.Amount = parseFloat(
    //     this.setAmount(row.Price, row.SkQuantity).toFixed(2)
    //   );
    // },

    compareUnitId(data, row, index, type) {

      if (type === 'before') {
        if (row.T === 3) row.T = 1;

        this.editT(row);

        let lastIsMain = row.IsMain;
        if (data.IsMain) {
          this.tableDataBefore[index].IsMain = false;
        } else {
          this.tableDataBefore[index].IsMain = true;
        }
        let findIndex = 0;
        if (row.UnitId == row.UnitId2) {
          let num = 0;
          num = row.SkQuantity;
          row.SkQuantity = row.Quantity2;
          row.Quantity2 = num;

          if (this.tableDataBefore[index].IsMain == false) {
            //当前选择的主单位
            findIndex = this.getUnitIndex(2, this.tableDataBefore[index].Units);
            this.changeLeftUnitId(index, findIndex, type);
            // row.ChangeType2 = data.ChangeType;
          } else {
            findIndex = this.getUnitIndex(1, this.tableDataBefore[index].Units);
            this.changeLeftUnitId(index, findIndex, type);
            // row.ChangeType2 = data.ChangeType;
          }
        } else {
          if (this.tableDataBefore[index].IsMain == false) {
            //当前选择的主单位
            findIndex = this.getUnitIndex(2, this.tableDataBefore[index].Units);
            this.changeLeftUnitId(index, findIndex, type);
            // row.ChangeType2 = data.ChangeType;
          } else {
            findIndex = this.getUnitIndex(1, this.tableDataBefore[index].Units);
            this.changeLeftUnitId(index, findIndex, type, data.Rate);
            // row.ChangeType2 = data.ChangeType;
            if (!lastIsMain) {
              row.SkQuantity = row.Quantity2;
            }
            // row.Quantity2 = (row.Quantity / Number(data.Rate)).toFixed(2);
            row.Quantity2 = this.getQuantity(row.SkQuantity / Number(data.Rate));
          }
        }
        this.changeQuantity2(this.tableDataBefore[index].Quantity2, row, index, 1);

        let val = this.setNumber(Math.abs(row.Amount / row.SkQuantity));
        row.Price = this.getPrice(val);

        val = this.setNumber(Math.abs(row.Amount / row.Quantity2));
        row.Price2 = this.getPrice(val);
      } else {
        if (row.T === 3) row.T = 1;

        this.editT(row);

        let lastIsMain = row.IsMain;
        if (data.IsMain) {
          this.tableDataAfter[index].IsMain = false;
        } else {
          this.tableDataAfter[index].IsMain = true;
        }
        let findIndex = 0;
        if (row.UnitId == row.UnitId2) {
          let num = 0;
          num = row.SkQuantity;
          row.SkQuantity = row.Quantity2;
          row.Quantity2 = num;

          if (this.tableDataAfter[index].IsMain == false) {
            //当前选择的主单位
            findIndex = this.getUnitIndex(2, this.tableDataAfter[index].Units);
            this.changeLeftUnitId(index, findIndex, type);
            // row.ChangeType2 = data.ChangeType;
          } else {
            findIndex = this.getUnitIndex(1, this.tableDataAfter[index].Units);
            this.changeLeftUnitId(index, findIndex, type);
            // row.ChangeType2 = data.ChangeType;
          }
        } else {
          if (this.tableDataAfter[index].IsMain == false) {
            //当前选择的主单位
            findIndex = this.getUnitIndex(2, this.tableDataAfter[index].Units);
            this.changeLeftUnitId(index, findIndex, type);
            // row.ChangeType2 = data.ChangeType;
          } else {
            findIndex = this.getUnitIndex(1, this.tableDataAfter[index].Units);
            this.changeLeftUnitId(index, findIndex, type, data.Rate);
            // row.ChangeType2 = data.ChangeType;
            if (!lastIsMain) {
              row.SkQuantity = row.Quantity2;
            }
            // row.Quantity2 = (row.Quantity / Number(data.Rate)).toFixed(2);
            row.Quantity2 = this.getQuantity(row.SkQuantity / Number(data.Rate));
          }
        }
        this.changeQuantity2(this.tableDataAfter[index].Quantity2, row, index, 1);

        let val = this.setNumber(Math.abs(row.Amount / row.SkQuantity));
        row.Price = this.getPrice(val);

        val = this.setNumber(Math.abs(row.Amount / row.Quantity2));
        row.Price2 = this.getPrice(val);
      }

    },
    changeLeftUnitId(index, findIndex, type, Rate = 0) {
      if (type === 'before') {
        this.tableDataBefore[index].UnitId =
          this.tableDataBefore[index].Units[findIndex].UnitId;
        this.tableDataBefore[index].SaUnitName =
          this.tableDataBefore[index].Units[findIndex].UnitName;
        // this.tableData[index].ChangeType1 =
        //   this.tableData[index].Units[findIndex].ChangeType;

        if (Rate > 0) {
          this.tableDataBefore[index].Rate = Rate;
        }
      } else {
        this.tableDataAfter[index].UnitId =
          this.tableDataAfter[index].Units[findIndex].UnitId;
        this.tableDataAfter[index].SaUnitName =
          this.tableDataAfter[index].Units[findIndex].UnitName;
        // this.tableData[index].ChangeType1 =
        //   this.tableData[index].Units[findIndex].ChangeType;

        if (Rate > 0) {
          this.tableDataAfter[index].Rate = Rate;
        }
      }

    },
    changeQuantity2(data, row, index, type = 0) {
      if (data == "-" || data == "." || data == "") {
        return;
      }
      this.editT(row);
      // if(this.data.MinusEntry){
      //       row.Quantity2=0-row.Quantity2
      //      }else{
      //       row.Quantity2=Math.abs(row.Quantity2)
      //      }
      // if (this.data.MinusEntry) {
      //   row.Quantity > 0 ? (row.Quantity = 0 - row.Quantity) : row.Quantity;
      //   row.Quantity2 > 0 ? (row.Quantity2 = 0 - row.Quantity2) : row.Quantity2;
      // } else {
      //   row.Quantity = Math.abs(row.Quantity);
      //   row.Quantity2 = Math.abs(row.Quantity2);
      // }
      if (row.T === 3) row.T = 1;
      if (row.IsMain == false) {
        if (row.ChangeType == 1 && row.SkQuantity != 0) {
          //row.Rate = Math.abs(Number(data / row.SkQuantity)).toFixed(2);
          if (row.HasGrammage == true) {
            row.SkQuantity = this.getQuantity(data * row.Rate)
          } else {
            row.Rate = this.getIinvexchrate(data / row.SkQuantity)
          }
          if (type === 0) {
            let val = this.setNumber(Math.abs(row.Amount / data));
            row.Price2 = this.getPrice(val);
          }
        } else {
          console.log("数量1=数量2/换算率");
          // row.Quantity=Number(data/row.Rate).toFixed(2);
          // row.SkQuantity = this.getQuantity(data / row.Rate);
          if (row.SkQuantity === 0) {
            row.SkQuantity = this.getQuantity(data * row.Rate)
          } else {
            row.SkQuantity = this.getQuantity(data / row.Rate)
          }
          if (type === 0) {
            row.Amount = this.setAmount(row.Price2, row.Quantity2);
          }
        }
      } else {
        if (row.ChangeType == 1 && row.SkQuantity != 0) {
          //row.Rate = Math.abs(Number(row.SkQuantity / data)).toFixed(2);
          if (row.HasGrammage == true) {
            row.SkQuantity = this.getQuantity(data / row.Rate)
          } else {
            row.Rate = this.getIinvexchrate(row.SkQuantity / data)
          }
          if (type === 0) {
            let val = this.setNumber(Math.abs(row.Amount / data));
            row.Price2 = this.getPrice(val);
          }
        } else {
          console.log("数量1=数量2*换算率");
          // row.Quantity=Number(data*row.Rate).toFixed(2);
          row.SkQuantity = this.getQuantity(data * row.Rate);
          if (type === 0) {
            row.Amount = this.setAmount(row.Price2, row.Quantity2);
          }
        }
      }
    },
    changePrice(val, row) {
      this.editT(row);

      val = this.setNumber(val);
      row.Price = this.getPrice(val);
      row.Amount = this.setAmount(row.Price, row.SkQuantity);

      if (row.UnitId2 && row.Quantity2 !== 0) {
        row.Price2 = this.getPrice(row.Amount / row.Quantity2);
      }
    },
    changePrice2(val, row) {
      this.editT(row);

      val = this.setNumber(val);
      row.Price2 = this.getPrice(val);

      row.Amount = this.setAmount(row.Price2, row.Quantity2);
      if (row.SkQuantity !== 0) {
        row.Price = this.getPrice(row.Amount / row.SkQuantity);
      }
    },
    editT(row) {
      if (row.T !== 0) {
        row.T = 1;
      }
    },
    changeAmount(val, row) {
      this.editT(row);

      // if (this.data.MinusEntry) {
      //   val = val > 0 ? 0 - val : val;
      // } else {
      //   val = Math.abs(val);
      // }
      row.Amount = this.setNumber(val);

      if (row.SkQuantity !== 0) {
        row.Price = this.getPrice(Math.abs(row.Amount / row.SkQuantity));
      } else {
        this.$message({ type: "warning", message: "数量不能为0" });
        row.Amount = 0;
        return;
      }

      if (row.Units.length > 0) {
        if (row.Quantity2 !== 0) {
          row.Price2 = this.getPrice(Math.abs(row.Amount / row.Quantity2));
        } else {
          this.$message({ type: "warning", message: "数量2不能为0" });
          row.Amount = 0;
          return;
        }
      }


    },
    RateChange(data, row, index) {
      if (data < 0 || data == "") return;
      if (row.T === 3) row.T = 1;
      row.Rate = data;
      row.Rate = Number(row.Rate).toFixed(2);
      // this.changeQuantity(this.tableData[index].Quantity,row,index)
      if (row.IsMain) {
        // row.Quantity2 = (row.Quantity / Number(data)).toFixed(2);
        if(row.HasGrammage==true){
          row.Quantity2 = this.getQuantity(row.SkQuantity * Number(data));

        }else{
          row.Quantity2 = this.getQuantity(row.SkQuantity / Number(data));
        }
      } else {
        // row.Quantity = (row.Quantity2 / Number(data)).toFixed(2);
        if(row.HasGrammage==true){
          row.SkQuantity = this.getQuantity(row.Quantity2 * Number(data));

        }else{
          row.SkQuantity = this.getQuantity(row.Quantity2 / Number(data));
        }
      }

      let val = this.setNumber(row.Amount / row.SkQuantity);
      row.Price = this.getPrice(val);

      val = this.setNumber(row.Amount / row.Quantity2);
      row.Price2 = this.getPrice(val);
    },
    setAmount(p, q) {
      return Number((p * q).toFixed(2));
    },
    onSelect(e, row, type) {
      console.log(e, 'e')
      row.Colors = [];
      row.Units = [];

      row.ColorId = null;
      row.PropertyId = null;

      row.UnitName = "";
      row.ColorName = "";
      row.IsBatchNumber = e.BatchNumber ?? false
      row.BatchNumber = null
      row.BatchStartDate = row.IsBatchNumber ? row.BatchStartDate : null
      row.Grammage= e.Grammage,
      row.HasGrammage= e.HasGrammage,
      row.Variable= e.Variable
      row.ProductName = e.ProductName;
      row.ProductNo = e.ProductNo;
      row.ProductId = e.ProductId;
      row.ProductSpec = e.ProductSpec;
      row.Colors = e.Colors;
      row.Units = e.Units;
      //SkUnitName
      row.UnitId = e.SkUnitId;
      row.UnitName = e.SkUnitName;
      row.UnitType = e.UnitType
      row.ChangeType = 0;
      row.UnitType = 0;
      row.UseColor = e.UseColor;
      row.UseProcess = e.UseProcess;
      //unit_Api
      // this.unit_Api.list({
      //   IsGroup: false,
      //   Status:true
      // }).then(res => {
      //   if(res.Code === 0){
      //     row.Units=res.Data
      //   }
      // })
      // if) row.Unit2Name=e.SaUnitName


      if (e.Units.length === 0) {
        row.UnitId = e.SkUnitId;
        row.UnitName = e.SkUnitName;
      } else {
        row.UnitType = 1;
        e.Units.forEach((item) => {
          if (item.ChangeType == 1) row.ChangeType = item.ChangeType;
        });
        if (row.UnitId) {
          let index = this.getUnitIndex(3, e.Units, row.UnitId);
          let data = this.getUnitValue(e.Units, index);
          let assistIndex = 0;
          let assistData = {};
          row.IsMain = data.IsMain;
          row.UnitName=data.UnitName;
          if (data.IsMain) {
            assistIndex = this.getUnitIndex(2, e.Units);
            assistData = this.getUnitValue(e.Units, assistIndex);
            row.Rate = assistData.Rate.toFixed(5);
          } else {
            assistIndex = this.getUnitIndex(1, e.Units);
            assistData = this.getUnitValue(e.Units, assistIndex);
            row.Rate = data.Rate.toFixed(5);
          }
          row.UnitId2 = assistData.UnitId;
          row.UnitName2 = assistData.UnitName;
        } else {
          let untiLength = e.Units.length;
          let mainData = [];
          let noMainData = [];
          for (let i = 0; i < untiLength; ++i) {
            if (e.Units[i].IsMain) {
              mainData.push(e.Units[i])
            } else {
              noMainData.push(e.Units[i])
            }
          }
          row.UnitId = mainData[0].UnitId;
          row.UnitName = mainData[0].UnitName;
          row.UnitId2 = noMainData[0].UnitId;
          row.UnitName2 = noMainData[0].UnitName;
          row.Rate = noMainData[0].Rate.toFixed(5);
          row.IsMain = true;
        }

      }


    },
    resetFun() {
      this.pageParams.pageIndex = 1
      this.DAccount = this.initDAccount
      this.listTotal = this.initTotal
    },
    currentPage({ val, text1 }, row) {
      this.pageParams.pageIndex = val
      this.pdApi.list({ pageIndex: val, pageSize: 7, Status: 1, ProductName: text1 }).then((res) => {
        if (res.Code == 0) {
          this.DAccount = res.Data;
          this.listTotal = res.Count
        }
      });
    },
    inputText(text, row) {
      console.log(row);
      row.ProductName = text;
      this.pdApi.list({ pageIndex: 1, pageSize: 7, ProductName: text, Status: 1, }).then((res) => {
        if (res.Code == 0) {
          this.DAccount = res.Data;

          this.listTotal = res.Count
        }
      });
    },
    getProducts(data, type = 0) {
      let Products = [];

      if (type === 0) {
        data.forEach((item) => {
          let {
            T,
            GoodsChgId,
            GoodsChgBeginDetailId,
            WarehouseId,
            WarehouseName,
            ProductId,
            ProductNo,
            ProductName,
            ProductSpec,
            PropertyId,
            PropertyName,
            ColorId,
            ColorName,
            UnitId,
            UnitName,
            SkQuantity,
            Price,
            Amount,

            UnitId2,
            UnitName2,
            Quantity2,
            Price2,
            Rate,
            BatchNumber,
            TaxRate,
            TaxPrice,
            TaxAmount,
            TaxLimit,
            ChangeType,
            Remark,
            UseColor,
            UseProcess,
          } = item;

          PropertyId = PropertyId ? PropertyId : 0;
          ColorId = ColorId ? ColorId : 0;
          WarehouseId = WarehouseId ? WarehouseId : 0
          UnitId = UnitId ? UnitId : 0;
          Price2 = Price2 ? Price2 : 0;
          Rate = Rate ? Rate : 0;
          Quantity2 = Quantity2 ? Quantity2 : 0;

          let o = {
            T,
            GoodsChgId,
            GoodsChgBeginDetailId,
            WarehouseId,
            WarehouseName,
            ProductId,
            ProductNo,
            ProductName,
            ProductSpec,
            PropertyId,
            PropertyName,
            ColorId,
            ColorName,
            UnitId2: UnitId2,
            UnitId2Name: UnitName2,
            SkQuantity,
            Price,
            Amount,
            SkUnitId: UnitId,
            SkUnitName: UnitName,
            Quantity2,
            Rate,
            BatchNumber,
            TaxRate,
            Price2,
            TaxPrice,
            TaxAmount,
            TaxLimit,
            ChangeType,
            Remark,
            UseColor,
            UseProcess,
          };

          Products.push(o);
        });
      } else {
        data.forEach((item) => {
          let {
            T,
            GoodsChgId,
            GoodsChgEndDetailId,
            WarehouseId,
            WarehouseName,
            ProductId,
            ProductNo,
            ProductName,
            ProductSpec,
            PropertyId,
            PropertyName,
            ColorId,
            ColorName,
            UnitId,
            UnitName,
            SkQuantity,
            Price,
            Amount,

            UnitId2,
            UnitName2,

            Quantity2,
            Rate,
            BatchNumber,
            TaxRate,
            Price2,
            TaxPrice,
            TaxAmount,
            TaxLimit,
            ChangeType,
            Remark,
            UseColor,
            UseProcess,
          } = item;

          PropertyId = PropertyId ? PropertyId : 0;
          ColorId = ColorId ? ColorId : 0;
          WarehouseId = WarehouseId ? WarehouseId : 0
          UnitId = UnitId ? UnitId : 0;
          Price2 = Price2 ? Price2 : 0;
          Rate = Rate ? Rate : 0;
          Quantity2 = Quantity2 ? Quantity2 : 0;


          let o = {
            T,
            GoodsChgId,
            GoodsChgEndDetailId,
            WarehouseId,
            WarehouseName,
            ProductId,
            ProductNo,
            ProductName,
            ProductSpec,
            PropertyId,
            PropertyName,
            ColorId,
            ColorName,
            UnitId2: UnitId2,
            UnitId2Name: UnitName2,
            SkQuantity,
            Price,
            Amount,
            SkUnitId: UnitId,
            SkUnitName: UnitName,
            Quantity2,
            Rate,
            BatchNumber,
            TaxRate,
            Price2,
            TaxPrice,
            TaxAmount,
            TaxLimit,
            ChangeType,
            Remark,
            UseColor,
            UseProcess,
          };

          Products.push(o);
        });
      }


      return Products;
    },
    save(type = 0) {

      //验证表单是否填写
      let yanzheng = ['ChgDate', 'ChgNumber', 'DpId', 'EmpId']
      for (let key in this.data) {
        if (yanzheng.indexOf(key) !== -1 && (!this.data[key])) {
          this.$message({ type: 'warning', message: '表单未填写完整' })
          return;
        }
      }

      let BeginDetailModels = this.getProducts(this.tableDataBefore);
      this.headKeepData = BeginDetailModels;
      if (BeginDetailModels.length > 0 && BeginDetailModels[0].ProductName != '') {
      } else {
        this.$message({ type: 'warning', message: '明细列表不能为空' })
        return
      }
      BeginDetailModels = BeginDetailModels.concat(this.delTableDataBefore);

      BeginDetailModels = BeginDetailModels.filter((item) => {
        return item.T != null && item.ProductId !== 0 && item.ProductId != null;
      });

      let EndDetailModels = this.getProducts(this.tableDataAfter, 1);
      this.footKeepData = EndDetailModels;

      EndDetailModels = EndDetailModels.concat(this.delTableDataAfter);

      EndDetailModels = EndDetailModels.filter((item) => {
        return item.T != null && item.ProductId !== 0 && item.ProductId != null;
      });

      let BeginDetailModelsLength = BeginDetailModels.length;
      for (let i = 0; i < BeginDetailModelsLength; ++i) {
        if (BeginDetailModels[i].UseColor && BeginDetailModels[i].ColorId === 0) {
          this.$message.error(`存货${BeginDetailModels[i].ProductName}未填写颜色`)
          return;
        }
        if (BeginDetailModels[i].UseProcess && BeginDetailModels[i].PropertyId === 0) {
          this.$message.error(`存货${BeginDetailModels[i].ProductName}未填写属性`)
          return;
        }
        if (!BeginDetailModels[i].SkQuantity) {
          this.$message({ type: 'warning', message: '存货数量不能为0' })
          return
        }
        if( !BeginDetailModels[i].WarehouseId||BeginDetailModels[i].WarehouseId === 0){
          this.$message({ type: 'warning', message: '转换前仓库不能为空' })
          return
        }
        if(!BeginDetailModels[i].Price){
          BeginDetailModels[i].Price=0;
        }
      }

      let EndDetailModelsLength = EndDetailModels.length;
      for (let i = 0; i < EndDetailModelsLength; ++i) {
        if (EndDetailModels[i].UseColor && EndDetailModels[i].ColorId === 0) {
          this.$message.error(`存货${EndDetailModels[i].ProductName}未填写颜色`)
          return;
        }
        if (EndDetailModels[i].UseProcess && EndDetailModels[i].PropertyId === 0) {
          this.$message.error(`存货${EndDetailModels[i].ProductName}未填写属性`)
          return;
        }
        if (!EndDetailModels[i].SkQuantity) {
          this.$message({ type: 'warning', message: '存货数量不能为0' })
          return
        }
        if( !EndDetailModels[i].WarehouseId||EndDetailModels[i].WarehouseId === 0){
          this.$message({ type: 'warning', message: '转换后仓库不能为空' })
          return
        }
        if(!EndDetailModels[i].Price){
          EndDetailModels[i].Price=0;
        }
      }


      let o = {
        BeginDetailModels,
        EndDetailModels,
        ...this.data,
      };

      this.api.save(o).then((res) => {
        if (res.Code === 0) {
          if (this.viewType === "create") {
            this.data.GoodsChgId = res.Data;
          }
          if (type !== 1) {
            this.$message.success(res.Msg);
          }
          this.isSave = true;

          this.api.info(this.data.GoodsChgId).then((res) => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data;

              if (type === 1) {
                this.reView1()
              } else {
                this.editInit(res.Data, 'keep');
              }
            }
          });
        } else {
          this.$message({ type: "warning", message: res.Msg });
        }
      });
    },
    del(row, index, type) {
      this.$confirm("确认删除这条数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((res) => {
        if (type === "before") {
          if (row.T !== 0) {
            row.T = 2;
            row.PropertyId = row.PropertyId ? row.PropertyId : 0;
            row.ColorId = row.ColorId ? row.ColorId : 0;
            row.WarehouseId = row.WarehouseId ? row.WarehouseId : 0
            row.UnitId = row.UnitId ? row.UnitId : 0;
            this.delTableDataBefore.push(row)
          }
          this.tableDataBefore.splice(index, 1);
          if (this.tableDataBefore.length === 0) {
            this.newLine("before");
          }
        } else {
          if (row.T !== 0) {
            row.T = 2;
            row.PropertyId = row.PropertyId ? row.PropertyId : 0;
            row.ColorId = row.ColorId ? row.ColorId : 0;
            row.WarehouseId = row.WarehouseId ? row.WarehouseId : 0
            row.UnitId = row.UnitId ? row.UnitId : 0;
            this.delTableDataAfter.push(row)
          }

          this.tableDataAfter.splice(index, 1);
          if (this.tableDataAfter.length === 0) {
            this.newLine("after");
          }
        }
      });
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },
    newLine(type) {
      let o = {
        T: 0,
        GoodsChgId: 0,
        GoodsChgBeginDetailId: 0,
        ChgNumber: "",
        WarehouseId: null,
        WarehouseName: "",
        ProductId: null,
        ProductNo: "",
        ProductName: "",
        ProductSpec: "",
        PropertyId: null,
        PropertyName: "",
        ColorId: null,
        ColorName: "",
        Colors: [],
        Units: [],
        UnitId: null,
        UnitId2: 0,
        UnitName: "",
        UnitName2: "",
        SkQuantity: null,
        Price: null,
        Amount: null,
        SkUnitId: 0,
        SkUnitName: "",
        Quantity2: null,
        Rate: null,
        BatchNumber: "",
        TaxRate: 0,
        Price2: null,
        TaxPrice: 0,
        TaxAmount: 0,
        TaxLimit: 0,
        Remark: "",
      };
      this.tableDataBefore.push(o);

    },
    newLine_after() {
      let o = {
        T: 0,
        GoodsChgId: 0,
        GoodsChgBeginDetailId: 0,
        ChgNumber: "",
        WarehouseId: null,
        WarehouseName: "",
        ProductId: null,
        ProductNo: "",
        ProductName: "",
        ProductSpec: "",
        PropertyId: null,
        PropertyName: "",
        SkQuantity: null,
        ColorId: null,
        ColorName: "",
        Colors: [],
        Units: [],
        UnitId: null,
        UnitId2: 0,
        UnitName: "",
        UnitName2: "",
        Price: null,
        Amount: null,
        SkUnitId: 0,
        SkUnitName: "",
        Quantity2: null,
        Rate: null,
        BatchNumber: "",
        TaxRate: 0,
        Price2: null,
        TaxPrice: 0,
        TaxAmount: 0,
        TaxLimit: 0,
        Remark: "",
      };
      this.tableDataAfter.push(o);
    },
    add(row, column, e, type) {
      if ((column.label && column.label === "操作") || this.Status === 2) {
        return;
      }
      if (type === "before") {
        if (row.index === this.tableDataBefore.length - 1) {
          this.newLine();
        }
      } else {
        if (row.index === this.tableDataAfter.length - 1) {
          this.newLine_after();
        }
      }
    },
    newAdd() {
      if (!this.isSave) {
        this.$message({ type: "warning", message: "请先进行保存再操作" });
        return;
      } else {
        Object.assign(this.$data, this.$options.data.call(this));
        this.getPreviewNo();
        this.$route.params.type = "create";
        this.viewType = "create";
        this.init();
        this.resetDom = Date.now()
        this.isSave = false;
      }
    },
    reView1() {
      let id = this.data.GoodsChgId;
      this.api.review(id).then((res) => {
        if (res.Code === 0) {
          this.$message({ type: "success", message: res.Msg });
          this.api.info(this.data.GoodsChgId).then((res) => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data;
              this.editInit(res.Data);
            }
          });
        } else {
          this.$message({ type: "warning", message: res.Msg });
        }
      });
    },
    reView() {
      this.save(1)
    },
    cancelReView() {
      let id = this.data.GoodsChgId;
      this.api.back(id).then((res) => {
        if (res.Code === 0) {
          this.$message({ type: "success", message: res.Msg });
          this.api.info(this.data.GoodsChgId).then((res) => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data;
              this.editInit(res.Data);
            }
          });
        } else {
          this.$message({ type: "warning", message: res.Msg });
        }
      });
    },
    handleDelete() {
      let Id = this.data.GoodsChgId;
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((res) => {
        this.api.delete({ Id }).then((res) => {
          if (res.Code === 0) {
            this.$message({ type: "success", message: res.Msg });
            this.newAdd();
            // this.$emit('deleted')
          } else {
            this.$message({ type: "warning", message: res.Msg });
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown-item {
  padding: 6px;
}

.mtx10 {
  padding: 10px;
}

.flex {
  display: flex;
  .text {
    width: 60px;
  }
}
.space-between {
  justify-content: space-between;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex1 {
  flex: 1;
}

.mrx18 {
  margin-right: 18px;
}

.div {
  font-size: 14px;
  margin-top: 10px;
}

.span {
  display: inline-block;
  width: 180px;
}
</style>
